module.exports = __webpack_public_path__ + "img/img05.94f873f3.png";